import { CashPlusPortfolioState } from "@modules/cashplus/+state/cashplus-portfolio.state.service";
import { Fiat } from "@models";
import { CashPlusPortfolioApi } from "@modules/cashplus/entities/cashplus.model";
import { toTargetCurrency } from "@helpers/tradable-convert";
import { CashplusWidgetViewModel } from "@modules/cashplus/ui/cashplus-widget/cashplus-widget.facade";
import { CashPlusConfigurationState } from "@modules/cashplus/+state/cashplus-configurations.state.service";

export function calculateCashBalance(
	cashPlusPortfolioState: CashPlusPortfolioState,
	cashPlusConfigurationState: CashPlusConfigurationState,
	defaultFiat: Fiat,
	existingFiats: Fiat[]
): CashplusWidgetViewModel {
	const cashBalances: CashplusWidgetViewModel = {
		cashBalance: 0.0,
		cashPlusBalance: 0.0,
		totalRewards: 0.0,
		defaultFiatId: defaultFiat.getId(),
		error: cashPlusPortfolioState.error || cashPlusConfigurationState.error
	};

	if (cashBalances.error) {
		return cashBalances;
	}
	// aggregate cash plus values from all wallets
	cashPlusPortfolioState.fiatConfigs?.forEach((fiatBalance: CashPlusPortfolioApi) => {
		const currentFiat = existingFiats.find((fiat) => fiat.getPid() === fiatBalance.asset_pid);
		cashBalances.cashBalance += toTargetCurrency(
			parseFloat(fiatBalance.available_asset_balance),
			defaultFiat,
			currentFiat
		);
		cashBalances.cashPlusBalance += toTargetCurrency(
			parseFloat(fiatBalance.parked_asset_balance),
			defaultFiat,
			currentFiat
		);
		cashBalances.totalRewards += toTargetCurrency(parseFloat(fiatBalance.total_rewards), defaultFiat, currentFiat);
	});
	return cashBalances;
}
